import { Title } from '@vkontakte/vkui';
import React from 'react';
import { getSize } from 'reactApp/utils/sizeHelper';

import styles from './Header.css';
interface HeaderProps {
    title: string;
    size: number;
}

export const Header: React.FC<HeaderProps> = ({ title, size }) => {
    return (
        <div className={styles.root}>
            <Title level="1" weight="2">
                {title}
            </Title>
            <Title level="3" weight="2">
                Занято: {getSize(size)}
            </Title>
        </div>
    );
};
